import { render, staticRenderFns } from "./DeliveryInserts.vue?vue&type=template&id=15ab6ec3&"
import script from "./DeliveryInserts.vue?vue&type=script&lang=js&"
export * from "./DeliveryInserts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports